import React from 'react';
import { Box, Text, List, ListItem } from '@opendoor/bricks/core';
import { MarginProps } from '@opendoor/bricks/system/theme';
import { CheckmarkIcon } from 'shared/components/Checklists';

/** Specific descriptions to show if the user is in the SSVA targeting experiment */
export const SSVA_TARGETING_ORVA_DESCRIPTIONS = [
  'Get live instructions, ask questions',
  'Book a time that works best for you',
  'See a final offer in a few days',
];

/** The default descriptions we always use */
export const DEFAULT_ORVA_DESCRIPTIONS = [
  'An expert will review your info',
  'You’ll get a final offer in a few days',
];

interface VAChecklistProps {
  /** Items to show in the checklist */
  items: string[];
  /** Optional title to display */
  title?: string;
}

/**
 * VAChecklist renders the checklist on the VA schedule page
 * component-test-check-ignore
 */
export const VAChecklist: React.FC<MarginProps & VAChecklistProps> = ({
  items,
  title,
  ...marginProps
}) => (
  <Box bg="neutrals10" borderRadius="semiRounded" p={7} {...marginProps}>
    {!title && (
      <Text fontWeight="semibold" fontSize={['s00', 's1']}>
        {title}
      </Text>
    )}
    <List variant="text">
      {items.map((description, index) => (
        <ListItem
          key={`va-selection-description-${index}`}
          alignItems="center"
          display="flex"
          mt={4}
          _first={{ mt: title ? 4 : 0 }}
        >
          <CheckmarkIcon />
          <Text fontSize={['s00', 's0']} ml="4">
            {description}
          </Text>
        </ListItem>
      ))}
    </List>
  </Box>
);
